import React from "react";
export function Footer() {
  return <footer className="border-t border-line bg-paper" data-id="element-76" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-3xl px-5 py-10 text-center text-sm text-muted" data-id="element-77" data-mp="3gfsoqi9xf4pm">
        <p className="font-display text-base font-bold text-ink" data-id="element-78" data-mp="32o4ao9g4a660">RecursoPDF © 2026</p>
        <p className="mt-1" data-id="element-79" data-mp="36pfshssr1n3n">Recursos digitales creados para aprender, explorar y poner en práctica.</p>
        <p className="mt-4 text-xs leading-relaxed" data-id="element-80" data-mp="3uf0nja26gata">
          El contenido de este producto tiene fines educativos, creativos y de bienestar general. No sustituye atención
          psicológica, médica ni profesional.
        </p>
      </div>
    </footer>;
}